import httpClient from '../utils/http'
import { handleResponseAsync } from '../utils/HelperUtils'
import moment from 'moment'
import { normalize } from 'normalizr'
import _ from 'lodash'
import { viewConstants } from './../_constants/view.constants'
import { leaveSchema } from './../entities/schema'

export const employeeLeaveService = {
    fetchEmployeeLeave,
}

function convertViewModelList(data) {
    let viewModel = []
    if (!_.isEmpty(data) && _.isArray(data)) {
        data.map(o => {
            const m = {}
            m.id = o.PayrollEmpLeaveAutoID
            m.start = moment(o.PayrollEmpLeaveDate).toDate()
            m.end = moment(o.PayrollEmpLeaveEndDate).toDate()
            m.EmployeeID = o.PayrollEmpLeaveEmployeeID
            m.Title = o.title
            m.ActionType = o.PayrollEmpLeaveTypeID
            viewModel.push(m)
        })
    }

    const leaveListSchema = [leaveSchema]
    const normalizedData = normalize(viewModel, leaveListSchema)
    return normalizedData.entities
}


function fetchEmployeeLeave(options) {
    const url = '/api/leave'

    const defaultQueryCond = {
        range: viewConstants.MONTH,
        time: new Date(),
    }

    let queryCond = options || defaultQueryCond

    return httpClient
    .post(url, queryCond)
    .then(handleResponseAsync)
    .then(res => convertViewModelList(res.data))
}